module.exports = __webpack_public_path__ + "img/Safe.4f821107.png";